var map = {
	"./draft/draft.module.ngfactory": [
		"hh4S",
		5
	],
	"./league/league.module.ngfactory": [
		"cc4L",
		6
	],
	"./matchup/matchup.module.ngfactory": [
		"5+L0",
		7
	],
	"./myteam/myteam.module.ngfactory": [
		"Wvbo",
		8
	],
	"./resultboard/resultboard.module.ngfactory": [
		"JjTq",
		4
	],
	"./settings/settings.module.ngfactory": [
		"ZwRP",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;